export default {
  path: "/data",
  name: "GDOT Crash Data",
  htmlContent: "data.html",
  headings: [],
};
